{
  "version": 1,
  "assets": {
    "officialChineseLogo": {
      "path": "/game/ui/classic/officialChineseLogo.png",
      "width": 239,
      "height": 124,
      "crop": [
        328,
        13,
        567,
        137
      ],
      "sourcePath": "research/source-inspection/classic-ui/official-legacy-bg.jpg",
      "sourceSha256": "7ada8123a3d9284a590f920b382a636af661fefd22e2e78a2204c54df202c680",
      "sha256": "cc4493066145faaa658ce56793d85302e2e58d18364a2a3b13786db5a4def5d7",
      "originalUrl": "https://webpic.my4399.com/ddt/images/bg.jpg",
      "cssUrl": "https://web.4399.com/ddt/images/style.css",
      "savedPage": "assets/reference/official/pages/legacy_home_2010.html",
      "derivation": "Unmodified original pixel rectangle crop of the Chinese brand logo from the official legacy website background; pink backing preserved without recoloring, masking or repainting",
      "candidateConfidence": "Official Chinese legacy-site logo candidate referenced by a saved 2010 legacy-page layout; exact 2009/2010 bitmap publication date is unverified",
      "note": "Original source website background contains a March 11 server-opening banner; this is not used as proof of logo age."
    }
  }
}
